/* eslint-disable @typescript-eslint/no-empty-function */

import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    selector: "circ-top-bar",
    templateUrl: "./top-bar.component.html",
    styleUrls: ["./top-bar.component.scss"],
    standalone: false
})
export class TopBarComponent {
  @Output() public toggleClick = new EventEmitter();

  constructor() {}

  toggleNav(): void {
    this.toggleClick.emit();
  }
}
